<template>
    <vs-popup :title="title" :active.sync="popupOpen">
        <h5 class="mb-4 flex items-center">
            <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success"/>
            Добавлено связок: {{info.added_relations}}
        </h5>
        <h5 class="mb-4 flex items-center">
            <feather-icon icon="AlertCircleIcon" class="mr-4" svg-classes="text-warning"/>
            Изменено связок: {{info.updated_relations ? info.updated_relations : 0}}
        </h5>
        <h5 class="mb-4 flex items-center">
            <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger"/>
            Удалено связок: {{info.deleted_relations ? info.deleted_relations.length : 0}}
        </h5>
        <h5 class="mb-4 flex items-center">
            <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success"/>
            Добавлено пользователей: {{info.added_users}}
        </h5>
    </vs-popup>
</template>

<script>
    export default {
        name: "FullApartmentsUsersImportPopup",
        props: {
            title: {
                default: null
            },
            isOpen: {
                default: false,
            },
            info: {
                default: null,
            }
        },
        computed: {
            popupOpen: {
                get(){
                    return this.isOpen;
                },
                set(value){
                    this.$emit('openChanged', value);
                }
            }
        }
    }
</script>
